import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { MenuItem } from "@material-ui/core";

import DropdownMenu from "app/components/DropdownMenu";
import { getCurrentUserFromState } from "app/app.selectors";
import CurrentUserAvatar from "app/components/CurrentUserAvatar";
import { logout, changeUser } from "features/login/login.actions";

const UserDropdown = ({ dispatchChangeUser, dispatchLogout }) => {
  return (
    <DropdownMenu Trigger={<CurrentUserAvatar />}>
      <MenuItem onClick={dispatchChangeUser}>Change user</MenuItem>
      <MenuItem onClick={dispatchLogout}>Logout</MenuItem>
    </DropdownMenu>
  );
};

export default compose(
  connect(
    state => ({
      currentUser: getCurrentUserFromState(state),
    }),
    {
      dispatchLogout: logout,
      dispatchChangeUser: changeUser,
    },
  ),
)(UserDropdown);
